import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (err) {
      setError(err.message === 'Invalid login credentials'
        ? 'Incorrect email or password. Please try again.'
        : err.message);
    } else {
      navigate('/');
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <Logo />
        <h1 style={styles.title}>Welcome back</h1>
        <p style={styles.sub}>Sign in to your restaurant portal</p>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email address</label>
            <input
              type="email" value={email} required
              onChange={e => setEmail(e.target.value)}
              placeholder="owner@restaurant.com"
              style={styles.input}
            />
          </div>
          <div style={styles.field}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
              <label style={styles.label}>Password</label>
              <Link to="/forgot-password" style={{ fontSize: '0.8rem', color: 'var(--orange)', fontWeight: 600, textDecoration: 'none' }}>
                Forgot password?
              </Link>
            </div>
            <input
              type="password" value={password} required
              onChange={e => setPassword(e.target.value)}
              placeholder="Your password"
              style={styles.input}
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}

          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <p style={styles.footer}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: 'var(--orange)', fontWeight: 600 }}>
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}

function Logo() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', marginBottom: '2rem' }}>
      <svg width="38" height="38" viewBox="0 0 120 120">
        <defs>
          <linearGradient id="lg" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#E85D04"/>
            <stop offset="100%" stopColor="#F48C06"/>
          </linearGradient>
        </defs>
        <path d="M20 30 C20 20, 30 10, 50 10 L70 10 C90 10, 100 20, 100 30 L100 60 C100 70, 90 80, 70 80 L40 80 L20 95 L20 80 C20 80, 20 70, 20 60 Z" fill="url(#lg)" opacity="0.9"/>
        <rect x="40" y="35" width="40" height="4" fill="white" rx="2"/>
        <rect x="42" y="39" width="4" height="25" fill="white" rx="2"/>
        <rect x="74" y="39" width="4" height="25" fill="white" rx="2"/>
        <rect x="38" y="64" width="44" height="6" fill="white" rx="3"/>
        <circle cx="85" cy="25" r="8" fill="#0A6847"/>
        <path d="M85 20 L85 30 M80 25 L90 25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      <span style={{ fontFamily: 'Fraunces, serif', fontSize: '1.3rem', fontWeight: 900, color: 'var(--ink)' }}>
        Table<span style={{ color: 'var(--orange)' }}>Chat</span>
      </span>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'var(--cream)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  card: {
    background: 'white',
    borderRadius: 16,
    padding: '2.5rem',
    width: '100%',
    maxWidth: 420,
    border: '1px solid var(--border)',
    boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
  },
  title: {
    fontFamily: 'Fraunces, serif',
    fontSize: '1.7rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '0.4rem',
    color: 'var(--ink)',
  },
  sub: {
    textAlign: 'center',
    color: 'var(--mid)',
    fontSize: '0.9rem',
    marginBottom: '2rem',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '1.2rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
  label: { fontSize: '0.85rem', fontWeight: 600, color: 'var(--ink)' },
  input: {
    padding: '0.8rem 1rem',
    border: '1.5px solid var(--border)',
    borderRadius: 8,
    fontSize: '0.95rem',
    outline: 'none',
    transition: 'border-color 0.2s',
    color: 'var(--ink)',
    background: 'white',
  },
  error: {
    background: 'var(--red-bg)',
    color: 'var(--red-tx)',
    padding: '0.75rem 1rem',
    borderRadius: 8,
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  btn: {
    background: 'var(--orange)',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    padding: '0.9rem',
    fontSize: '0.95rem',
    fontWeight: 700,
    cursor: 'pointer',
    transition: 'background 0.2s',
    marginTop: '0.4rem',
  },
  footer: {
    textAlign: 'center',
    fontSize: '0.875rem',
    color: 'var(--mid)',
    marginTop: '1.5rem',
  },
};
